import { FormVue } from "./index.js";

(window as any).FormVueContent = FormVue;

export { FormVue };
export type { FormVueContentOptions } from "../shared/schema-types.js";
export type { ContentConfig } from "../shared/types.js";
